export const getIndividualServicePageUrl: (
  type: string,
  slug: string
) => string = (type = '', slug = '') => {
  switch (type) {
    case 'text':
      return `/writing-services/${slug}/`
    case 'seo':
      return `/seo-writing-services/${slug}/`
    case 'demandGen':
      return `/demand-generation-writing-services/${slug}/`
    case 'design':
      return `/design-services/${slug}/`
    case 'vernacular':
      return `/language-services/${slug}/`
    case 'video':
      return `/video-services/${slug}/`
    case 'language':
      return `/languages/${slug}/`
    case 'industries':
      return `/industries/${slug}/`
    default:
      return `/services/${slug}/`
  }
}

export const getIndividualServiceSlugType: (
  slug: string
) => StrapiServiceCategory | null = (slug = '') => {
  switch (slug) {
    case 'writing-services':
      return `text`
    case 'seo-writing-services':
      return `seo`
    case 'demand-generation-writing-services':
      return `demandGen`
    case 'design-services':
      return `design`
    case 'language-services':
      return `vernacular`
    case 'video-services':
      return `video`
    default:
      return null
  }
}

export const stripHtmlTags = (string: string) => {
  return string.replace(/<[^>]*>?/gm, '')
}

export const getFormatRgbaColor = (color: string) => {
  const formatColor = color.replace(/_/, '(').replace(/_/g, ',') + ')'
  return formatColor
}

export function sliceArrayIntoChunks(arr: unknown[], chunkSize: number) {
  const response: unknown[] = []
  arr.forEach((_, i) => {
    if (i % chunkSize === 0) {
      const chunk = arr.slice(i, i + chunkSize)
      response.push(chunk)
    }
  })
  return response
}

export const mmddyyyyDateFormat = (date: string) => {
  const dateObj = new Date(date)

  const options: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: '2-digit',
    year: 'numeric'
  }

  return dateObj.toLocaleDateString('en', options)
}
